export default IconArrowRampRight3 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-ramp-right-3" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M6 3v6" />
  <path d="M16 16l4 -4l-4 -4" />
  <path d="M6 21v-6a3 3 0 0 1 3 -3h11" />
</svg>`;